module.exports = __webpack_public_path__ + "static/media/laravel.fc069933.svg";